import IconeAjuda from '@/global/components/IconeAjuda'
import Grid from '@/global/components/ui/Grid'
import {
    CardRadioForm,
    FormField,
    FormFieldCheckbox,
} from 'global/components/Form'
import { Link } from 'global/components/Link'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

function FormularioEscala() {
    const { setValue, watch } = useFormContext()
    const emHoras = watch('emHoras') as boolean

    const trabalha = useMemo(() => {
        if (emHoras) {
            return (
                <FormField
                    name="trabalha"
                    label="Trabalha (em horas)"
                    options={{
                        blocks: [2, 2],
                        delimiter: ':',
                    }}
                    onBlur={handleBlur(value => setValue('trabalha', value))}
                />
            )
        }

        return (
            <FormField
                name="trabalha"
                label="Trabalha (em dias)"
                type="number"
            />
        )
    }, [emHoras])

    const folga = useMemo(() => {
        if (emHoras) {
            return (
                <FormField
                    name="folga"
                    label="Folga (em horas)"
                    options={{
                        blocks: [2, 2],
                        delimiter: ':',
                    }}
                    onBlur={handleBlur(value => setValue('folga', value))}
                />
            )
        }

        return <FormField name="folga" label="Folga (em dias)" type="number" />
    }, [emHoras])

    return (
        <Grid container>
            <Grid item xs={12}>
                <CardRadioForm
                    label="Como a escala é contada?"
                    name="emHoras"
                    options={[
                        {
                            value: true,
                            titulo: 'Em horas',
                            descricao:
                                'Trabalha e folga informados em horas (hh:mm)',
                        },
                        {
                            value: false,
                            titulo: 'Em dias',
                            descricao:
                                'Trabalha e folga informados em dias inteiros',
                        },
                    ]}
                />
            </Grid>
            <Grid item xs={12}>
                <FormFieldCheckbox
                    name="horaExtraNoFeriado"
                    label="Hora extra no feriado"
                    endAdornment={
                        <IconeAjuda>
                            <ul className="pl-4">
                                <li>
                                    O colaborador receberá hora extra no feriado
                                    se selecionado.
                                </li>
                                <br />
                                <li>
                                    Por padrão, só recebe se ultrapassar a
                                    jornada de trabalho.
                                </li>
                                <br />
                                <li>
                                    Se não trabalhar, não há hora extra.
                                    Configure a porcentagem na{' '}
                                    <Link href="/cadastros/regras-calculo">
                                        regra de cálculo
                                    </Link>{' '}
                                    na linha feriado.
                                </li>
                            </ul>
                        </IconeAjuda>
                    }
                />
            </Grid>
            <Grid item xs={6}>
                {trabalha}
            </Grid>
            <Grid item xs={6}>
                {folga}
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="descricao"
                    label="Descrição/Nome da escala"
                    required
                />
            </Grid>
        </Grid>
    )
}

export default FormularioEscala

function handleBlur(fn: (value: string) => void) {
    return (
        event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        const { value } = event.target

        if (!value) return fn('')

        return fn(value.padEnd(5, '0'))
    }
}
